<app-popin (close)="cancelled.emit()" [show]="show">
  <div class="flex flex-col pr-4 pl-4 pb-4 mt-2 text-center">
    <p class="text-secondary text-xl font-bold mb-7">
      {{ 'go_back_to_bank_choice_confirmation' | translate }}
    </p>
    <div class="flex flex-row justify-center mb-2">
      <button
        (click)="cancelled.emit()"
        class="flex-1 text-secondary rounded-full pr-8 pl-8 pt-2 pb-2 border-secondary border-2 font-bold mr-5"
      >
        {{ 'cancel' | translate }}
      </button>
      <button
        (click)="confirmed.emit()"
        class="flex-1 text-secondary rounded-full pr-8 pl-8 pt-2 pb-2 bg-primary font-bold"
      >
        {{ 'ok' | translate }}
      </button>
    </div>
  </div>
</app-popin>
